<template>
    <UTooltip class="select-none" :ui="{ base: '!h-auto' }">
        <UBadge color="sky" label="Credential" variant="subtle" />
        <template #text>
            <div class="p-2 space-y-1">
                <Field
                    v-for="[key, value] in entries"
                    :key="key"
                    :label="formatKey(key)"
                    label-class="text-[11px] uppercase text-gray-400"
                    inline
                >
                    <span>{{ value }}</span>
                </Field>
            </div>
        </template>
    </UTooltip>
</template>

<script setup lang="ts">
const props = defineProps<{
    fields: Record<string, string>
}>()

const entries = computed(() => Object.entries(props.fields))

function formatKey(key: string) {
    return key.replaceAll('_', ' ')
}
</script>
